import React, { useEffect, useState } from "react";
import _ from "lodash";
import { ChevronUp } from "../../utils/assets/chevronUp";
import { Check } from "../../utils/assets/check";
import { ChvronDown } from "../../utils/assets/chevronDown";
import useIsMobile from "../../utils/detectDevice";
import { HStack, VStack } from "../utils";
import { MultiSelectPropsType, OptionTypes } from "./MultiSelect";

export function MultiSelectV2(props: MultiSelectPropsType) {
  const {
    multiple,
    placeholder,
    label,
    _className,
    handleSelection,
    optionValues,
  } = props;
  const [state, setState] = useState<any>({
    values: optionValues,
    focusedValue: -1,
    isFocused: false,
    isOpen: false,
    typed: "",
  });

  useEffect(() => {
    if (!_.isEqual(state.values, optionValues)) {
      setState((prev: any) => ({ ...prev, values: optionValues }));
    }
  }, [optionValues]);

  const { isMobile } = useIsMobile();
  function onClick() {
    setState({ ...state, isOpen: !state.isOpen });
  }

  function onOutsideClick() {
    setState({ ...state, isOpen: false });
  }

  function onDeleteOption(e: any) {
    const { value } = e.currentTarget.dataset;

    setState((prevState: any) => {
      const [...values] = prevState.values;
      const index = values.indexOf(value);
      values.splice(index, 1);
      return { values };
    });
  }
  useEffect(() => {
    handleSelection(state.values);
  }, [state]);

  function onClickOption(e: any) {
    const { value } = e.currentTarget.dataset;
    setState((prevState: any) => {
      if (!multiple) {
        return {
          values: [value],
          isOpen: false,
        };
      }

      const [...values] = prevState.values;
      const index = values.indexOf(value);

      if (index === -1) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }
      return { values };
    });
    e.stopPropagation();
  }

  function stopPropagation(e: any) {
    e.stopPropagation();
  }

  function renderValues() {
    const { values } = state;

    if (values.length === 0) {
      return <div className="placeholder text-sm py-0.5">{placeholder}</div>;
    }

    if (multiple) {
      return values.map((value: any) => (
        <div
          key={value}
          className="relative z-10 items-center p-2 m-1 text-sm font-medium leading-normal border rounded border-orange-501 value multiple"
          onClick={(e) => stopPropagation(e)}
        >
          {value}
          <span
            data-value={value}
            onClick={(e) => onDeleteOption(e)}
            className="absolute pl-2 py-0.5 px-1 text-orange-501  cursor-pointer r-0 t-0"
          >
            <X />
          </span>
        </div>
      ));
    }

    return <VStack className="">{values[0]}</VStack>;
  }

  function renderOptions() {
    const { options } = props;
    const { isOpen } = state;

    if (!isOpen) {
      return null;
    }

    return (
      <div
        className="options"
        style={{
          height: `${
            options.length <= 3
              ? "130"
              : options.length <= 5 && options.length >= 3
              ? "160"
              : "200"
          }px`,
        }}
      >
        {options.map((option: OptionTypes, index: number) =>
          renderOption(option, index)
        )}
      </div>
    );
  }

  function renderOption(option: OptionTypes, index: number) {
    const { values, focusedValue } = state;

    const { value } = option;

    const selected = values.includes(value);

    let className = "option ";
    if (selected) className += " selected";
    if (index === focusedValue) className += " focused";

    return (
      <div
        key={value}
        data-value={value}
        className={className}
        onClick={(e) => onClickOption(e)}
      >
        {multiple ? (
          <span className="checkbox">{selected ? <Check /> : null}</span>
        ) : null}
        {value}
      </div>
    );
  }

  const { isOpen } = state;

  return (
    <VStack
      onMouseLeave={() => onOutsideClick()}
      className={` rounded relative `}
    >
      <HStack
        className={`relative items-center justify-between h-full text-sm font-normal border border-solid multiple-form-select ${_className}`}
        onClick={() => onClick()}
      >
        <div className="">{renderValues()}</div>
        <div className="absolute flex items-center p-2 text-sm font-normal text-center right-2">
          {isOpen ? <ChevronUp /> : <ChvronDown />}
        </div>
      </HStack>
      <div>{renderOptions()}</div>
    </VStack>
  );
}
export const X = () => (
  <svg
    viewBox="0 0 16 16"
    width={"1em"}
    height={"1em"}
    fill="currentColor"
    display={"block"}
  >
    <path d="M2 .594l-1.406 1.406.688.719 5.281 5.281-5.281 5.281-.688.719 1.406 1.406.719-.688 5.281-5.281 5.281 5.281.719.688 1.406-1.406-.688-.719-5.281-5.281 5.281-5.281.688-.719-1.406-1.406-.719.688-5.281 5.281-5.281-5.281-.719-.688z" />
  </svg>
);
